import React from 'react';

/**
 * Componente de card para exibir uma estatística chave (KPI).
 * @param {object} props - Propriedades do componente.
 * @param {React.Element} props.icon - O ícone a ser exibido no card.
 * @param {string} props.title - O título da estatística.
 * @param {string|number} props.value - O valor da estatística.
 * @param {string} props.description - Uma breve descrição da estatística.
 * @param {string} props.colorClass - Classe de cor para o fundo do ícone.
 * @param {function} [props.onClick] - Função a ser executada ao clicar no card.
 * @returns {React.Component} O componente do card de estatística.
 */
const StatCard = ({ icon, title, value, description, colorClass, onClick }) => {
    const handleKeyDown = (e) => {
        if (onClick && (e.key === 'Enter' || e.key === ' ')) {
            e.preventDefault();
            onClick(e);
        }
    };

    return (
        <div
            onClick={onClick}
            role={onClick ? 'button' : undefined}
            tabIndex={onClick ? 0 : undefined}
            onKeyDown={onClick ? handleKeyDown : undefined}
            aria-label={onClick ? `${title}: ${value}. ${description || ''}` : undefined}
            className={`bg-white dark:bg-slate-800 p-6 rounded-2xl shadow-lg flex items-start gap-4 transition-all duration-200 ${
                onClick
                    ? 'cursor-pointer hover:shadow-xl hover:scale-105 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 dark:focus-visible:ring-offset-slate-800'
                    : ''
            }`}
        >
            {/* Container do Ícone */}
            <div className={`p-3 rounded-full ${colorClass}`}>
                {icon}
            </div>
            {/* Container do Conteúdo */}
            <div>
                <p className="text-sm font-medium text-slate-500 dark:text-slate-400">{title}</p>
                <p className="text-2xl font-bold text-slate-900 dark:text-slate-100">{value}</p>
                <p className="text-xs text-slate-400 dark:text-slate-500">{description}</p>
            </div>
        </div>
    );
};

// Optimized: Wrapped in React.memo to prevent unnecessary re-renders when the parent component updates.
export default React.memo(StatCard);
